import Layout from "~/components/ui/Layout";
import TicketRegister from "~/components/tickets/TicketRegister";
import PatternById from "~/components/ui/PatternById";
import { useWindowSize } from "~/components/ui/hooks";

export default function Register() {
  const { windowWidth } = useWindowSize();

  return (
    <Layout>
      <TicketRegister />
      {windowWidth ? (
        <PatternById
          id="footerShapes"
          width={windowWidth * 0.15}
          lgOnly
          position={{ bottom: 0, right: "5%" }}
        />
      ) : null}
    </Layout>
  );
}
